"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dom_1 = __importDefault(require("react-dom"));
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
const CONSTANTS = __importStar(require("../../common/constants"));
const cookies_manager_1 = require("../../common/cookies_manager");
const App_1 = require("../App");
const constants_1 = require("../../common/constants");
const process_helpers_1 = require("../../common/process_helpers");
const HEADER_I18N_STRINGS = {
    searchIconAriaLabel: 'Search',
    searchDismissIconAriaLabel: 'Close search',
    overflowMenuTitleText: 'Menu',
    overflowMenuTriggerText: 'More',
};
const HEADER_IDENTITY = {
    href: '#',
    title: CONSTANTS.SERVICE_NAME,
};
const ServiceHeader = () => {
    // The header component is rendered outside the DOM hierarchy of the parent component
    // See: https://reactjs.org/docs/portals.html#gatsby-focus-wrapper
    const username = sessionStorage.getItem(CONSTANTS.SESSION_STORAGE_USERNAME);
    const cookieLocale = cookies_manager_1.CookiesManager.getCookie(CONSTANTS.COOKIE_EDM_LOCALE);
    const localeDescription = constants_1.LANGUAGE_MAP.get(cookieLocale);
    const headerProfileActions = [{ id: 'sign out', text: 'Sign out' }];
    const headerLocaleActions = Array.from(constants_1.LANGUAGE_MAP).map(([locale, description]) => {
        return { id: locale, text: description };
    });
    // const { selectedProcess, onProcessChange } = useContext(SelectedProcessContext);
    // const { processes, isProcessesLoading } = useContext(ProcessesContext);
    const process = (0, process_helpers_1.useProcess)();
    const { localizationContext, setLocalizationContext } = (0, react_arb_tools_1.useLocalizationContext)();
    const toggleLocale = (locale) => {
        cookies_manager_1.CookiesManager.setCookie(CONSTANTS.COOKIE_EDM_LOCALE, locale);
        setLocalizationContext((0, App_1.localizationContextBuilder)().withLocale(locale).build());
    };
    const onSignOutClick = () => {
        sessionStorage.clear();
        localStorage.clear();
        // TODO: Redirect to some goodbye page for sign out, or refresh the page
    };
    const headerUtilities = [
        {
            type: 'button',
            variant: 'link',
            external: true,
            text: 'EDM WIKI',
            href: CONSTANTS.SERVICE_WIKI_LINK,
        },
        {
            type: 'menu-dropdown',
            text: process.selectedProcess !== CONSTANTS.PROCESS_PLACEHOLDER
                ? process.selectedProcess
                : 'Loading processes...',
            description: 'Process filter',
            items: process.processes.map((process) => {
                return { text: process, id: process };
            }),
            onItemClick: (event) => {
                process.onSelectedProcessChange(event.detail.id);
            },
        },
        {
            type: 'menu-dropdown',
            text: localeDescription,
            description: 'Language',
            items: headerLocaleActions,
            onItemClick: (event) => {
                toggleLocale(event.detail.id);
            },
        },
        {
            type: 'menu-dropdown',
            text: username ? username : 'Username',
            description: `${username ? username : 'Username'}@amazon.com`,
            iconName: 'user-profile',
            items: headerProfileActions,
            onItemClick: (event) => {
                if (event.detail.id === 'sign out') {
                    onSignOutClick();
                }
            },
        },
    ];
    const domNode = document.querySelector('#h');
    return react_dom_1.default.createPortal((0, jsx_runtime_1.jsx)(awsui_components_react_1.TopNavigation, { id: 'header', className: 'header', i18nStrings: HEADER_I18N_STRINGS, identity: HEADER_IDENTITY, utilities: headerUtilities }), domNode);
};
exports.ServiceHeader = ServiceHeader;
